export default __webpack_public_path__ + "static/media/hht1_ep10_book_wp_02.6053ee64.jpg";